/**
 * Public API of the analytics layer. Components import ONLY from here
 * (`import { trackEvent, EVENTS } from '../../../analytics'`), never from
 * '@moengage/web-sdk' or the internal files.
 *
 * Independent of CleverTap / GTM / telemetry: nothing here reads or writes
 * those, so they can be removed later without touching this layer.
 */
import { initMoEngage } from './moengageClient';
import { registerAnalyticsStore } from './context';
import { getAnalyticsSessionId, hasAnalyticsSession } from './commonProps';
import { trackEvent } from './track';
import { EVENTS } from './events';

export { EVENTS, ALL_EVENT_NAMES } from './events';
export { EVENT_SCHEMA } from './eventSchema';
export { trackEvent, trackOnce, deferEvent, flushDeferredEvent, cancelDeferredEvent } from './track';
export { EKYC_JOURNEY_MAP, EKYC_MAIN_EVENTS, EKYC_OTHER_EVENTS, resolveJourneyEvent } from './moengageJourneyMap';
export {
    identifyUser, setUserProfile, rememberUserDetails, rememberEsignAttempt, logoutUser,
} from './user';
export { setCommonProps } from './commonProps';
export { default as RouteChangeTracker } from './RouteChangeTracker';

/**
 * Call once at module level in src/index.js, after the redux store exists.
 * Never throws. The SDK itself downloads later, at browser idle time.
 * @param {{ store?: { getState: () => any } }} [options]
 * @returns {void}
 */
export const initAnalytics = (options = {}) => {
    try {
        registerAnalyticsStore(options.store);
        initMoEngage();
        // web_session_init_en: once per browser-tab session (sessionStorage id).
        // Web-only (not in the handover) — trackEvent drops it while SEND_WEB_ONLY_EVENTS is false.
        if (!hasAnalyticsSession()) {
            getAnalyticsSessionId();
            trackEvent(EVENTS.JOURNEY.WEB_SESSION_INIT);
        }
    } catch (_) {
        /* analytics must never break app start-up */
    }
};
